import Router from './routes';
import ThemeProvider from './theme';
import ScrollToTop from './components/scroll-to-top';
import { StyledChart } from './components/chart';
import { Broadcast } from './components/Broadcast';
import { SnackBar } from './components/SnackBar';
import { SessionProvider } from './components/SessionProvider';
import Socket from './components/Socket/Socket';
import TourGuide from './components/TourGuide/TourGuide';
// import ProGPTBotLoader from './components/ProGPTBotLoader';

export default function App() {
  return (
    <ThemeProvider>
      <SessionProvider />
      <Broadcast />
      <TourGuide />
      <SnackBar />
      <Socket />
      <ScrollToTop />
      <StyledChart />
      {/* <ProGPTBotLoader /> */}
      <Router />
    </ThemeProvider>
  );
}
